import { useEffect, useState, useContext } from "react";
import Select from 'react-select';
import { ddStyles } from "../utils/CommonStyles.js";
import FetchUtil from "../utils/FetchUtil";
import { useNavigate } from "react-router-dom";
import UserContext from "../contexts/UserContext";

let deptOptions = [];
let subsidiaryOptions = [];

function SubsidiaryDepartmentTableRow({ index, userSubsidiaries, handleSubmit, setError, t, setAdd, oddIdx }) {
	const navigate = useNavigate();
	const [deptLoaded, setDeptLoaded] = useState(false);
	const [deptSelected, setDeptSelected] = useState({ name: "departmentKey", label: "", value: 0 });
	const [userSubsidiaryLoaded, setUserSubsidiaryLoaded] = useState(false);
	const [userSubsidiarySelected, setUserSubsidiarySelected] = useState({ name: "subsidiaryKey", label: "", value: 0 });
	const [isSubmit, setIsSubmit] = useState(false);
	const [isCompLoading, setIsCompLoading] = useState(false);
	const userCtx = useContext(UserContext);
	
	let userCompanyId = (userCtx.role !== "SiteAdmin") ? userCtx.userCompanyId : 0;
	useEffect(() => {
		setUserSubsidiaryValues(userSubsidiaries);
	}, []);

	function setDepartmentValues(deptObj) {
		let deptValue = {};
		deptOptions = [];
		deptOptions.push({ label: "", value: 0 });
		if (deptObj && deptObj.length > 0) {
			deptObj.map((aDept, idx) => {
				deptValue.label = aDept.departmentName;
				deptValue.value = aDept.departmentKey;
				deptOptions.push(deptValue);
				deptValue = {};
			});
			setDeptLoaded(true);
		}
	}
	const deptHandler = (selectedOption, action) => {
		let departmentKey = selectedOption ? selectedOption.value : 0;
		let departmentName = selectedOption ? selectedOption.label : "";
		setDeptSelected({ ...deptSelected, label: (departmentName), value: departmentKey });
	}
	function setUserSubsidiaryValues(subsidiaryObj) {
		let subsidiaryValue = {};
		subsidiaryOptions = [];
		if (subsidiaryObj && subsidiaryObj.length > 0) {
			subsidiaryObj.map((aSubsidiary, idx) => {

				subsidiaryValue.label = aSubsidiary.companyName;
				subsidiaryValue.value = aSubsidiary.companyId;
				subsidiaryOptions.push(subsidiaryValue);
				subsidiaryValue = {};
			});
			setUserSubsidiaryLoaded(true);
		}
	}
	const subsidiaryHandler = (selectedOption, action) => {
		let subsidiaryKey = selectedOption ? selectedOption.value : 0;
		let subsidiaryLabel = selectedOption ? selectedOption.label : "";
		setUserSubsidiarySelected({ ...userSubsidiarySelected, label: (subsidiaryLabel), value: subsidiaryKey });
		fetchSubsidiaryDepartments(subsidiaryKey);
	}
	function fetchSubsidiaryDepartments(subsidiaryKey) {
		setError("");
		if (!subsidiaryKey || subsidiaryKey === 0) {
			return;
		}

		setIsCompLoading(true);
		const requestOptions = {
			credentials: "same-origin",
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify({
				source: "web", getAll: false, companyId: subsidiaryKey,
				userCompanyId : userCompanyId
			}),
		};
		try {
			FetchUtil.fetchAPI("GetDepartments", "/Service/CompanyService/GetDepartments", requestOptions, retrieveDepartmentSuccess, retrieveDepartmentFail);
		} catch (error) {
			setIsCompLoading(false);
			throw new Error(error.message);
		}
	}

	function retrieveDepartmentFail(redirect) {
		setIsCompLoading(false);
		if (redirect) {
			navigate("/");
		}
		setError(t("error.deptNotRetrieved"));
	}

	function retrieveDepartmentSuccess(responseData) {
		let fetchDepartmentsResponse;
		if (responseData) {
			fetchDepartmentsResponse = responseData.fetchDepartmentsResponse;
			if (fetchDepartmentsResponse && fetchDepartmentsResponse.errorCode === "0") {
				setDepartmentValues(fetchDepartmentsResponse.departments.slice())
			} else if (fetchDepartmentsResponse && fetchDepartmentsResponse.errorCode === "114") {
				navigate("/", {
					state: {
						errorMessage: t("error.sessionTimeout"),
					},
				});
			} else if (fetchDepartmentsResponse) {
				setError(t("error.error") + " " + fetchDepartmentsResponse.errorMessage);
			} else {
				setError(t("error.system.fetch"));
			}
		}
		setIsCompLoading(false);
	}

	function submitComplete() {
		setIsSubmit(false);
	}
	function submitRow() {
		setError("");
		setIsSubmit(true);
		let initialValues = {
			departmentKey: deptSelected.value,
			subsidiaryCompanyId: userSubsidiarySelected.value,
		};

		if (!deptSelected.value || deptSelected.value === 0) {
			setError(t("error.deptNameReqd"));
			setIsSubmit(false);
		} else if(!userSubsidiarySelected.value || userSubsidiarySelected.value === 0){
			setError(t("error.subsidiaryReqd"));
			setIsSubmit(false);
		} else {
			handleSubmit(1, initialValues, submitComplete);
		}

	}
	function submitCancel() {
		setError("");
		setAdd(false);
	}
	return (
		<tr key={index}>
			<td className={oddIdx ? "list-td col odd" : "list-td col even"}>
				{userSubsidiaryLoaded ? <Select
					name="subsidiaryKey"
					options={subsidiaryOptions}
					onChange={subsidiaryHandler}
					placeholder={""}
					value={userSubsidiarySelected}
					isSearchable={true}
					isClearable={true}
					className="myselect"
					inputId="subsidiaryKey-input"
					styles={ddStyles}
				/>
				: <></>}
			</td>
			<td className={oddIdx ? "list-td col odd" : "list-td col even"}>
				{deptLoaded ? <Select
					name="departmentKey"
					options={deptOptions}
					onChange={deptHandler}
					placeholder={""}
					value={deptSelected}
					isSearchable={true}
					isClearable={true}
					className="myselect"
					inputId="departmentKey-input"
					styles={ddStyles}
				/>
				: <></>}
			</td>
			<td className={oddIdx ? "list-td col odd" : "list-td col even"}>{t("page.active")}</td>
			<td className={oddIdx ? "list-td col odd" : "list-td col even"}>
				<div id="submit-spinner"
					className={isSubmit ? "spinner-border spinner-border-sm text-dark spinner-size" : "spinner-hide"}
				>
				</div>
				{(deptOptions && deptOptions.length >0 && subsidiaryOptions && subsidiaryOptions.length > 0) ?
					(<button className={isSubmit ? "btn btn-primary btn-block me-4 mb-1 pe-none" : "btn btn-primary btn-block me-4 mb-1"} onClick={() => (submitRow())}>{t("page.submit")}</button>)
					:
					(<></>)
				}
				<button className={isSubmit ? "btn btn-primary btn-block me-4 mb-1 pe-none" : "btn btn-primary btn-block me-4 mb-1"} onClick={() => (submitCancel())}>{t("page.cancel")}</button></td>
		</tr>
	)

}
export default SubsidiaryDepartmentTableRow;